module.exports = __webpack_public_path__ + "img/nutridrink-protein-31x62.b110884d.jpg";